import { useEffect } from 'react'
import { AppThunk } from 'src/store/store'
import { Errcode } from 'src/constants/errcode'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { Cmdtypes } from 'src/constants/cmdtypes'
import { ResetErrText, setErrText } from 'src/store/Reducer/common/commonSlice'
import { setStatus } from 'src/store/Reducer/page/loginPageSlice'
import SessionStorageUtils from 'src/utils/SessionStorage.utils'

import { ResponseDataType } from 'src/types/websocket'
import { eventBus } from 'src/api/eventBus'
import useMatchHook from 'src/hooks/useMatch.hook'
import { socketConnectionClosed } from 'src/store/Reducer/socket/socketSlice'

const useLoginEventBus = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { updateStorageData, deleteStorageData } = SessionStorageUtils()
  const { m_login } = useMatchHook()
  const { pathname } = useLocation()

  useEffect(() => {
    const IsMemberConfirmResponseListener = eventBus.subscribe<unknown>(
      Cmdtypes.MEMBER_CHECK,
      handleIsMemberConfirmResponse,
    )
    const PreviousLogoutResponseListener = eventBus.subscribe<unknown>(
      Cmdtypes.PREVIOUS_LOGOUT,
      (message: ResponseDataType<unknown>) => dispatch(handlePreviousLogoutResponse(message)),
    )

    return () => {
      IsMemberConfirmResponseListener.unsubscribe()
      PreviousLogoutResponseListener.unsubscribe()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  const handleIsMemberConfirmResponse = (message: ResponseDataType<unknown>) => {
    const { Header } = message.responseData
    switch (Header.ErrCode) {
      case Errcode.SUCCESS:
        dispatch(setStatus('isMemberConfirm'))
        dispatch(ResetErrText())
        break
      case Errcode.IS_NOT_MEMBER:
      case Errcode.MISMATCH_SNS_TYPE:
        dispatch(setErrText(Header.ErrMsg))
        !m_login && navigate('/')
        deleteStorageData()
        dispatch(socketConnectionClosed())
        break
      case Errcode.LOCK_ID_FOR_PIN:
        dispatch(setStatus('pinMoreThanFiveTimes'))
        dispatch(setErrText(Header.ErrMsg))
        break
      default:
        console.error(Header)
        break
    }
  }

  const handlePreviousLogoutResponse = (message: ResponseDataType<unknown>): AppThunk => {
    return async (_dispatch, getState) => {
      const { SNSType, Email, VerifyPin, pinHash } = getState().LoginPage
      const { Header } = message.responseData
      if (Header.ErrCode === Errcode.SUCCESS) {
        updateStorageData('userInfo', {
          SNSType: SNSType,
          Email: Email,
          VerifyPin: VerifyPin,
          pinHash: pinHash,
        })
        window.location.replace(`${window.location.origin}/home`)
      } else console.error(Header)
    }
  }
}
export default useLoginEventBus
